import { useEffect, useState } from "react";
import "../styles/DocUpload.css"
import Dialog, { DialogProps } from "../components/dialog/Dialog";
import axios from "axios";
import { useAuth } from "../context/AuthContext";
import { useNavigate } from "react-router-dom";

interface FileData {
    id?: number | null,
    documentType: string;
    documentName: string;
    path?: string | null;
}

const DocUpload: React.FC = () => {
    const [docs, setDocs] = useState<FileData[]>([]);
    const { token } = useAuth();
    const navigate = useNavigate();

    useEffect(() => {
        const fetchRequiredDocs = async () => {
            try {
                const res = await axios.get("https://uragate.in/websites/springapi/driver-registration/v1/account/document-upload",
                    {
                        headers: {
                            Authorization: `Bearer ${token}`,
                            "Content-Type": "application/json",
                        },
                    }
                );
                setDocs(res.data);
                console.log(res.data)
            } catch (error) {
                console.error(error);
            }
        };
        fetchRequiredDocs();
    }, []);

    const handleUploaded = () => {
        window.location.reload()
    }

    return (
        <div className="upload-page">
            <div className="upload-main-container">
                <h2>Upload Documents</h2>
                <div className="upload-docs">
                    {docs?.map((doc, index) => (
                        <PickFile
                            token={token}
                            key={index}
                            fileData={doc}
                            onUploaded={handleUploaded} />
                    ))}
                </div>
                <button className="leave-btn" onClick={() => navigate("/", { replace: true })}>Leave for now</button>
            </div>
        </div>
    )
}

interface PickFileProps {
    token: string | null;
    fileData: FileData
    onUploaded: () => void
}

const PickFile: React.FC<PickFileProps> = ({ token, fileData, onUploaded }) => {
    const [alert, setAlert] = useState<DialogProps | null>(null);
    const [loading, setLoading] = useState<boolean>(false);

    const handleUpload = async (e: React.ChangeEvent<HTMLInputElement>) => {
        const name = e.target.name;
        const selectedFile = e.target.files?.[0] || null;
        if (selectedFile != null && token != null) {
            const formData = new FormData();
            formData.append("file", selectedFile);
            formData.append("metadata", new Blob([JSON.stringify({ documentType: name, documentName: fileData.documentName })], { type: "application/json" }));
            try {
                setLoading(true);
                const res = await axios.post("https://uragate.in/websites/springapi/driver-registration/v1/account/file", formData, {
                    headers: {
                        "Content-Type": "multipart/form-data",
                        Authorization: `Bearer ${token}`,
                    },
                });
                const data = res.data;
                setAlert({
                    type: "success",
                    title: "Success",
                    message: "Upload successful.",
                    btnName: "Okay",
                    onClick() {
                        onUploaded()
                        setAlert(null)
                    },
                });
            } catch (error: any) {
                console.error(error);
                setAlert({
                    type: "error",
                    title: "Error",
                    message: error.response?.data?.message || "Upload failed.",
                    btnName: "Okay",
                    onClick() {
                        setAlert(null)
                    },
                });
                return;
            } finally {
                setLoading(false);
            }
        }
    };


    const handleDelete = async (id?: number | null) => {
        if (!id && id == null) {
            setAlert({
                type: "error",
                title: "Error",
                message: "Document Id not found.",
                btnName: "Okay",
                onClick() {
                    setAlert(null)
                },
            });
        }
        try {
            setLoading(true);
            const res = await axios.delete(`https://uragate.in/websites/springapi/driver-registration/v1/account/file/${id}`,
                {
                    headers: {
                        Authorization: `Bearer ${token}`
                    },
                }
            );

            setAlert({
                type: "success",
                title: "Success",
                message: "Document removed successful.",
                btnName: "Okay",
                onClick() {
                    onUploaded()
                    setAlert(null)
                },
            });

        } catch (error: any) {
            console.error(error);
            setAlert({
                type: "error",
                title: "Error",
                message: error.response?.data?.message || "Deletion failed.",
                btnName: "Okay",
                onClick() {
                    setAlert(null)
                },
            });
            return;
        } finally {
            setLoading(false);
        }
    };


    return (
        <div className="doc-item">
            <p className="doc-title">{fileData.documentName}</p>
            <div className="file-upload-container">
                {(fileData.path && fileData.id) ?
                    <div className="file-picked-container">
                        <p>{fileData.path}</p>
                        <div className="file-picked-actions">
                            <button className="picked-action-btn view"
                                onClick={() => {
                                    const fileURL = "https://uragate.in/websites/webapi4/file/" + fileData.path
                                    window.open(fileURL, "_blank");
                                    URL.revokeObjectURL(fileURL);
                                }}>
                                <img src="/eye.png" alt="" />
                                View
                            </button>
                            <button className="picked-action-btn delete"
                                onClick={() => handleDelete(fileData.id)}>
                                <img src="/delete.png" alt="" />
                                Delete
                            </button>
                        </div>
                    </div> :
                    <label htmlFor={`file-picker-${fileData.documentType}`} className="file-pick-btn">
                        <img src="/plus.png" alt="" />
                        <input id={`file-picker-${fileData.documentType}`} type="file" name={fileData.documentType} onChange={handleUpload} />
                    </label>
                }
            </div>
            {alert &&
                <Dialog type={alert.type} title={alert.title} message={alert.message} btnName={alert.btnName} onClick={alert.onClick} />
            }

            {
                loading &&
                <div className="uploading-container">
                    <p>Uploading...</p>
                </div>
            }
        </div>
    )
}

export default DocUpload;